
<template>
    <div class="xr-bottom">    
      <mu-paper class="bottom-nav" v-if="bottomNavList.length>0">
        <mu-bottom-nav :value="bottomNav" @change="handleChange">
          <template v-for="bottomItem in bottomNavList">
            <template v-if="bottomItem.IconType==1">
              <mu-bottom-nav-item :to="bottomItem.Url" :value="bottomItem.Id" :title="bottomItem.Name" :icon="':'+ bottomItem.Icon" :key="bottomItem.Id"/>   
            </template>
            <template v-else>     
              <mu-bottom-nav-item :to="bottomItem.Url"  class="btnImg" :value="bottomItem.Id"  :key="bottomItem.Id">
                 <img :src="bottomItem.Icon" class="mu-bottom-item-icon mu-icon fa fa-time" style="width:40px; height:40px;transform:none;" />
              </mu-bottom-nav-item>
            </template>
          </template>
        </mu-bottom-nav>
      </mu-paper>
    </div>
</template>
<script>
export default {
    name :'XR-bottom',
    data(){
      return {
        bottomNav: '',
        bottomNavColor: "",
        bottomNavList:[],
        botUrl:''
      }
    },
    mounted(){
      this.getBottomList()
    },
    created() {
      this.fetchData()
    },
    watch: {
        'bottomNav': 'fetchData'
    },
    methods: {
      handleChange(val) {
        this.bottomNav = val;
      },
      fetchData () { 
        if(this.$route.path == "/") {
            this.bottomNav = 1
        }
        if(this.$route.path == "/retail/category") {
            this.bottomNav = 2
        }
        if(this.$route.path == "/shangquan/index") {
            this.bottomNav = 3
        }
        if(this.$route.path == "/retail/cart") {
            this.bottomNav = 4
        }
        if(this.$route.path == "/usercenter/index") {
            this.bottomNav = 5
        }
      },
      getBottomList(){
        var ths = this;   
        ths.$post(
          "/Shop/AdServer/GetSiteBottomNavList",{clientType: this.ClientType, navType:1}
        ).then(function(res) {
          if(!res.IsSuccess){
          }else{          
            ths.bottomNavList = res.Data;
          }
        });
      }
    }
  }
</script>
<style>

.xr-bottom .bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
}
.xr-bottom .bottom-nav .mu-bottom-nav .mu-buttom-item {
  min-width: 60px;
}
.xr-bottom .btnImg{
  padding: 5px 12px 10px;
}
.xr-bottom .bottom-nav .mu-bottom-nav .mu-ripple-wrapper{
  width: 0;
   /* background: #ff4981; */
}
.xr-bottom .bottom-nav .mu-bottom-item-active .mu-bottom-item-icon,.xr-bottom .bottom-nav .mu-bottom-item-active .mu-bottom-item-text{
  color: #ff4981;
}
.xr-bottom .mu-buttom-item-wrapper .fa-myshangquan1{
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/bottom/bottom.vue